const initialFileMetaDataCategoryState = {
  data : false,
  columns: false

}

export const FileMetaDataCategoryReducer = (state = initialFileMetaDataCategoryState, action = {}) => {    
  
    switch (action.type) {    
     
        case 'FILEMETADATACATEGORY':       
            return {
              ...state,
              data: action.fetchedFileMetaData.data.data,
              columns: action.fetchedFileMetaData.data.columns

            }
        
      
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/FileMetaDataCategoryReducer.js